import { MerchantService } from '../../services/merchant.service';
import { Merchant } from './../../Merchant';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-merchant-search-results',
  templateUrl: './merchant-search-results.component.html',
  styleUrls: ['./merchant-search-results.component.css']
})
export class MerchantSearchResultsComponent implements OnInit {
  @Input() results: Merchant[];
  constructor(private merchantService: MerchantService) {}

  ngOnInit() {}

  selectMerchant(merchant: Merchant) {
    this.merchantService.selectMerchant(merchant);
    this.storeRecentMerchant(merchant);
  }

  storeRecentMerchant(merchant: Merchant): void {
    this.merchantService.storeRecentMerchant(merchant);
  }
}
